"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./RadioButton.css");
var UIProps_1 = require("../../UIProps");
var react_1 = require("react");
var react_2 = require("react");
var RadioButtonTheme;
(function (RadioButtonTheme) {
    RadioButtonTheme["basic"] = "basic";
})(RadioButtonTheme = exports.RadioButtonTheme || (exports.RadioButtonTheme = {}));
var RadioButtonComp = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? RadioButtonTheme.basic : _b, props = __rest(_a, ["theme"]);
    var input = react_1.useRef(null);
    react_2.useEffect(function () {
        if (props.startChecked && input.current)
            input.current.checked = true;
    }, [props.startChecked]);
    return (React.createElement("label", { className: classnames_1.default('RadioButton', props.className, "RadioButton-" + theme, {
            'RadioButton-disabled': props.disabled,
        }) },
        React.createElement("input", __assign({}, UIProps_1.setUIProps(props), { ref: input, type: "radio", className: classnames_1.default('RadioButton_input'), name: props.name, value: props.value, disabled: props.disabled, onChange: function (e) {
                if (props.onChange)
                    props.onChange(e);
            } })),
        React.createElement("div", { className: 'RadioButton_toggle' }),
        props.children && (React.createElement("span", { className: "RadioButton_label" }, props.children))));
};
exports.RadioButton = React.memo(RadioButtonComp);
